import { createApi } from '@reduxjs/toolkit/query/react';
import { getMinMaxInvoiceDate, GetMinMaxInvoiceDateQuery, GetMinMaxInvoiceDateQueryVariables } from '../../graphql';
import { baseQuery } from '../../utils';

export const OpeningBalanceDateApi = createApi({
  reducerPath: 'OpeningBalanceDateApi',
  baseQuery: baseQuery,
  tagTypes: ['OpeningBalanceDateApi'],
  endpoints: (builder) => ({
    fetchOpeningBalanceDate: builder.query<GetMinMaxInvoiceDateQuery, GetMinMaxInvoiceDateQueryVariables>({
      query: (variables) => ({
        body: getMinMaxInvoiceDate,
        variables,
      }),
      keepUnusedDataFor: Infinity,
      providesTags: (result, error, { invoicetypecd }) => [
        { type: 'OpeningBalanceDateApi', id: invoicetypecd },
        { type: 'OpeningBalanceDateApi', id: 'ALL' },
      ],
    }),
  }),
});

export const { useFetchOpeningBalanceDateQuery, useLazyFetchOpeningBalanceDateQuery } = OpeningBalanceDateApi;
